'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _toObject = require('../data/toObject');

var _toObject2 = _interopRequireDefault(_toObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 根据参数中的字段为组件生成 contextTypes 属性
 * 用法：在 mixins 中添加 ContextMixin('name1', 'name2', ...)
 */
function ContextMixin() {
  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
    fields[_key] = arguments[_key];
  }

  return {
    contextTypes: (0, _toObject2.default)(fields, _lodashCompat2.default.identity, _lodashCompat2.default.constant(_lodashCompat2.default.noop))
  };
}

/**
 * 根据 contexts 为组件生成 childContextTypes 属性和 getChildContext 属性
 * 用法：在 mixins 中添加 ChildContextMixin({name1: value1, name2: value2, ...})
 */
function ChildContextMixin(contexts) {
  return {
    childContextTypes: _lodashCompat2.default.mapValues(contexts, _lodashCompat2.default.constant(_lodashCompat2.default.noop)),
    getChildContext: function getChildContext() {
      return _lodashCompat2.default.mapValues(contexts, function (context) {
        return _lodashCompat2.default.isFunction(context) ? context.bind(this) : context;
      }.bind(this));
    }
  };
}
ContextMixin.Child = ChildContextMixin;

/**
 * 与 M.ChildContextMixin 类似，但是添加一个 getter 而不是一个属性
 */
function ChildContextGetterMixin(contexts) {
  _lodashCompat2.default.each(contexts, function (context) {
    context.bind = context.apply;
  });
  return ChildContextMixin(contexts);
}
ContextMixin.ChildGetter = ChildContextGetterMixin;

exports.default = ContextMixin;